import {
  APPLE_DEVICE_SPECS,
  APPLE_VIEWPORT_INDEX,
} from '../data/apple-perf-index.generated';
import { isAppleMobileWebKit } from './is-apple-mobile';
import { readViewportKey } from './viewport-key';
import type { AppleDeviceMatch } from '../types';

export function resolveAppleDevice(viewportKey?: string | null): AppleDeviceMatch | null {
  if (!isAppleMobileWebKit()) return null;

  const key = viewportKey ?? readViewportKey();
  if (!key) {
    return {
      matched: false,
      viewportKey: '',
      skus: [],
      marketingNames: [],
      ramGb: null,
      maxLevel: null,
      ambiguous: false,
    };
  }

  const entry = APPLE_VIEWPORT_INDEX[key];
  if (!entry) {
    return {
      matched: false,
      viewportKey: key,
      skus: [],
      marketingNames: [],
      ramGb: null,
      maxLevel: null,
      ambiguous: false,
    };
  }

  const marketingNames = [...new Set(
    entry.skus.map((sku) => APPLE_DEVICE_SPECS[sku]?.marketingName).filter(Boolean),
  )] as string[];

  const chips = [...new Set(
    entry.skus.map((sku) => APPLE_DEVICE_SPECS[sku]?.chip).filter(Boolean),
  )];

  return {
    matched: true,
    viewportKey: key,
    skus: entry.skus,
    marketingNames,
    ramGb: entry.ramGb,
    maxLevel: entry.maxLevel,
    chip: chips.length === 1 ? chips[0] : undefined,
    ambiguous: entry.skus.length > 1 || marketingNames.length > 1,
  };
}
